import React, { useEffect, useState } from "react";
import { ShieldCheck, Lock, Trash2, Globe2 } from "lucide-react";
import api from "../../lib/api";
import StoreBadges from "./StoreBadges";

const ITEMS = [
  { icon: Lock, title: "Private by default", body: "Your cycle, pregnancy and wellness data is never shared unless you opt in — one tap, always revocable." },
  { icon: ShieldCheck, title: "Yours, always", body: "We never sell your data. Sharing with a partner is explicit, mutual and can be switched off instantly." },
  { icon: Trash2, title: "Delete anytime", body: "Change your mind? Erase your account and all your data permanently, right from the app — no emails, no waiting." },
];

export function TrustBand() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.publicStats().then(setStats).catch(() => {}); }, []);

  return (
    <section id="trust" className="relative mx-auto max-w-6xl px-6 py-20" data-testid="trust-band">
      <div className="glass relative overflow-hidden rounded-[2rem] p-8 sm:p-10">
        <div className="pointer-events-none absolute -left-20 -top-20 h-64 w-64 rounded-full bg-brand/10 blur-[100px]" />
        <div className="relative grid gap-10 lg:grid-cols-[1.1fr_1fr] lg:items-center">
          <div>
            <p className="eyebrow">Built on trust</p>
            <h2 className="mt-4 font-display text-3xl font-semibold text-mist sm:text-4xl">The most personal data deserves the most respect</h2>
            <div className="mt-8 space-y-5">
              {ITEMS.map((it) => (
                <div key={it.title} className="flex items-start gap-3.5">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand/12 text-brand"><it.icon size={18} /></span>
                  <div>
                    <div className="text-sm font-semibold text-mist">{it.title}</div>
                    <div className="mt-0.5 text-sm text-mist-muted">{it.body}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="rounded-2xl border border-white/[0.06] bg-white/[0.02] p-5 text-center">
                <div className="font-display text-3xl font-bold text-mist" data-testid="trust-band-members">{stats?.members ? stats.members.toLocaleString() : "—"}</div>
                <div className="mt-1 text-[11px] uppercase tracking-wider text-mist-muted">members &amp; growing</div>
              </div>
              <div className="rounded-2xl border border-white/[0.06] bg-white/[0.02] p-5 text-center">
                <div className="flex items-center justify-center gap-1.5 font-display text-3xl font-bold text-mist"><Globe2 size={22} className="text-brand-soft" />{stats?.countries || "—"}</div>
                <div className="mt-1 text-[11px] uppercase tracking-wider text-mist-muted">countries worldwide</div>
              </div>
            </div>
            <div className="rounded-2xl border border-white/[0.06] bg-white/[0.02] p-5">
              <div className="mb-3 text-[11px] font-semibold uppercase tracking-wider text-brand-soft">Get the app</div>
              <StoreBadges className="justify-start" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
